import { pb } from "@/utils/PocketBaseAdapter";
import { Ref } from "vue";

export const makeImageHandler = (fileRef: Ref<any>, previewRef: Ref<any>) => (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0] || null;
  fileRef.value = file;
  if (file && file.type.startsWith("image/")) {
    const reader = new FileReader();
    reader.onload = () => { previewRef.value = reader.result as string; };
    reader.readAsDataURL(file);
  } else {
    previewRef.value = null;
  }
};

export const fileUrl = (record: any,filename: string) => `${pb.baseUrl}/api/files/${record.collectionId}/${record.id}/${filename}`;

export const fetchAndSetFile = async (
  key: string,
  record: any,
  fileRef: Ref<File | null>,
  previewRef: Ref<string | null>,
  originalFiles: any,
) => {
  const filename = record[key];
  if (!filename) return;
  previewRef.value = fileUrl(record, filename);
  try {
    const res = await fetch(fileUrl(record, filename));
    const blob = await res.blob();
    const file = new File([blob], filename, { type: blob.type });
    fileRef.value = file;
    originalFiles[key] = file;
  } catch {
    fileRef.value = null;
  }
};
